import { Feature } from '../../components/feature';
import Button from '../../components/Button';

export default function Support() {
  return  <Feature
        badge={"AI Powered Support for Indian Schools"}
        title={"AI Powered Support for Schools"}
        description={
          <>
            <p>
              Your school's 24×7 smart helper. Just like modern fighter jets use AI self-healing tech to stay strong in the sky, SooMuch.ai brings the same power to schools on the ground.
            </p>
          </>
        }
        imageAlt="digital markting"
        imageQuery="images/new-landing-page/supportv2.png"
        cta={
          <div className="mt-8 flex items-center gap-6 md:flex-col md:justify-center">
              <Button label='Book Live Demo' type='gradient' />
              <Button label="Claim ₹5 Lakh Free Access" type='outlined' />
            </div>
        }
      />
}